var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "iconografia/24/search-24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconografia/24/search-24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.032,21.314 L15.232,14.535 C17.9657588,11.41533 17.7313863,6.68937729 14.7023754,3.85549825 C11.6733644,1.02161921 6.9422865,1.1020008 4.01129191,4.03714107 C1.08029732,6.97228134 1.00660284,11.7034682 3.84476033,14.7284706 C6.68291783,17.753473 11.4091971,17.9811655 14.525,15.243 L21.325,22.024 L22.032,21.314 Z M9.481,16.152 C6.78678602,16.1524045 4.35763682,14.5297604 3.32632549,12.0407473 C2.29501416,9.55173426 2.86465419,6.6865554 4.76960816,4.7813154 C6.67456214,2.87607539 9.53965544,2.3060052 12.0288233,3.33694282 C14.5179912,4.36788044 16.141,6.79678599 16.141,9.491 C16.1371428,13.1677795 13.1577789,16.1475908 9.481,16.152 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch24);
export default __webpack_public_path__ + "static/media/search-24.b276393cfa4cd86cbf8bd40207b4e76e.svg";
export { ForwardRef as ReactComponent };